// Discriminates the SendStatusContent shape so consumers branch on a named constant instead of a bare string.
export const SEND_STATUS_CONTENT_KIND = {
  Text: 'text',
  Pending: 'pending',
  Badge: 'badge',
} as const;

// Keeps the status value cell a constant height across the send button / badge / finished-row spacer so rows never jump.
export const SEND_STATUS_CELL_HEIGHT = 28;

// Badge entrance: subtle fade + scale so the green badge reads as the shimmer resolving, not a hard swap.
export const BADGE_ENTRANCE = { duration: 220, fromScale: 0.92 } as const;

// Pending pulse: the label's opacity breathes between full and min so it reads as actively working.
export const PENDING_PULSE = { min: 0.4, duration: 850 } as const;
